import CommonModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";

interface DeleteConfigDialogProps {
    deleteConfigOpen: boolean;
    handleDeleteConfigClose: () => void;
    handleDeleteConfigConfirm: () => void;
}

const DeleteConfigDialog = (props: DeleteConfigDialogProps) => {
    const {deleteConfigOpen, handleDeleteConfigClose, handleDeleteConfigConfirm} = props;
    const element = (
        <div className="routerConfigDialogsContent">
            <div>
                <span className="routerConfigDialogTextLaligned">Config Name</span>
                <span></span>
            </div>
            <div>
                <span className="routerConfigDialogTextLaligned">Config ID</span>
                <span></span>
            </div>
            <div className="routerConfigDialogTextLaligned">The current configuration will be deleted.</div>
            <div className="routerConfigDialogTextLaligned">This action cannot be undone.</div>
        </div>
    )
    return(
        <CommonModal
            open={deleteConfigOpen}
            onClose={handleDeleteConfigClose}
            onSave={handleDeleteConfigConfirm}
            title={"Delete"}
            saveText={"Confirm"}
            showOnlineOffline={false}
            showSyncStatus={false}
            children={element}
            width={"430px"}
            height={"198px"}
        />
    )
}
export default DeleteConfigDialog;